const REQUEST_AUTH = state => {
  state.status = "fetching";
  state.errorMessage = "";
};

const SUCCESS_REQUEST_AUTH = (state, { body }) => {
  state.status = "success";
  state.errorMessage = "";
  localStorage.setItem("Authorization", body.token);
  state.tokenExpiresAt = body.expiresAt;
};

const FAILURE_REQUEST_AUTH = (state, payload = {}) => {
  state.status = "failure";
  state.errorMessage = payload.message || "E-Mail or password incorrect.";
};

const REQUEST_MYSELF = state => {
  state.statusMySelf = "fetching";
};

const SUCCESS_REQUEST_MYSELF = (state, { body }) => {
  state.statusMySelf = "success";
  state.mySelf = body;
};

const FAILURE_REQUEST_MYSELF = state => {
  state.statusMySelf = "failure";
};

const CLEAR_AUTH = state => {
  state.status = undefined;
  state.statusMySelf = undefined;
  state.mySelf = undefined;
  state.tokenExpiresAt = undefined;
};

export default {
  REQUEST_AUTH,
  SUCCESS_REQUEST_AUTH,
  FAILURE_REQUEST_AUTH,
  REQUEST_MYSELF,
  SUCCESS_REQUEST_MYSELF,
  FAILURE_REQUEST_MYSELF,
  CLEAR_AUTH
};
